import { render } from "./parabillard.vue?vue&type=template&id=3a09a013&ts=true"
import script from "./parabillard.vue?vue&type=script&lang=ts"
export * from "./parabillard.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__